import React from "react";
import Header2 from "../../components/Header2/Header2";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Homepage from "../HomePage/HomePage";
import HomePage2 from "../HomePage2/HomePage2";
// import HomePage3 from "../HomePage3/HomePage3";
import AboutUsPage from "../AboutUsPage/AboutUsPage";
import PricingPage from "../PricingPage/PricingPage";
import PortfolioPage from "../PortfolioPage/PortfolioPage";
import PortfolioSinglePage from "../PortfolioSinglePage/PortfolioSinglePage";
import TeamPage from "../TeamPage/TeamPage";
import TeamSinglePage from "../TeamSinglePage/TeamSinglePage";
import ServicePage from "../ServicePage/ServicePage";
import ServiceSinglePage from "../ServiceSinglePage/ServiceSinglePage";
import BlogPage from "../BlogPage/BlogPage";
import BlogDetails from "../BlogDetails/BlogDetails";
import ContactPage from "../ContactPage/ContactPage";
import Footer from "../../components/footer/Footer";
import CareerPage from "../CareerPage/CareerPage";
import PrivacyPolicy from '../../components/PrivacyPolicy/PrivacyPolicy';
import SEO from '../../components/SEO/SEO';

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <SEO />
        <Header2 />
        <Routes>
          <Route path="/" element={<HomePage2 />} />
          <Route path="career" element={<CareerPage/>} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route
            path="portfolio_details/:slug"
            element={<PortfolioSinglePage />}
          />
          <Route path="team" element={<TeamPage />} />
          <Route path="team-single/:slug" element={<TeamSinglePage />} />
          <Route path="service" element={<ServicePage />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog-single/:slug" element={<BlogDetails />} />
          <Route path="contact" element={<ContactPage />} />
          {/*<Route path="service_section" element={<ServiceSection /> } />*/}

        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
